import axios from 'axios';
import { createApiRequestUrl, CommonResult, OK } from '../Common';
import { API_EXCEPTION_MSG } from '../../Common';

/**
 * 取扱商材管理取得APIのリクエスト
 */
export interface GetHndlItmMngApiRequest {
  /** 取扱商材管理取得要求リスト */
  hndlItmMngList: HndlItmMng[];
}

/**
 * 取扱商材管理取得APIのレスポンス
 */
export interface GetHndlItmMngApiResponse {
  /** 取扱商材管理取得応答リスト */
  hndlItmMngMstList?: HndlItmMngMst[];
  /** 取扱商材管理取得結果 */
  hndlItmMngListResult: HndlItmMngListResult;
  /** 処理結果情報 */
  result: CommonResult;
}

interface HndlItmMng {
  /** 代理店コードリスト */
  agencyCd: string;
  /** 取扱商材区分 */
  hndlItmCfc: string;
}

/**
 * 取扱商材管理取得応答
 */
export interface HndlItmMngMst {
  /** 取次店コード */
  ordcstmCd: string;
  /** 取次店正式名称	 */
  longNm: string;
  /** 取次店略称 */
  shortNm: string;
  /** チェックデジット付取次店コード */
  chkdegtOrdcstmCd: string;
  /** 企業区分 */
  companyCfc: string;
  /** 取扱商材区分 */
  hndlItmCfc: string;
  /** 取扱商材区分正式名称 */
  hndlItmCfcLongNm: string;
  kanaNm: string;
}

interface HndlItmMngListResult {
  /** 取得件数 */
  hit: number;
}

/**
 * 取扱商材管理取得API
 * @param request リクエスト
 */
export async function getHndlItmMngList(request: GetHndlItmMngApiRequest): Promise<GetHndlItmMngApiResponse> {
  const url = createApiRequestUrl('hndlItmMng');
  try {
    const response = await axios.post<GetHndlItmMngApiResponse>(url, request);
    const data = response.data;
    const status = response.status;

    switch (status) {
      case OK.status:
        return data;
      default:
        throw new Error(data.result.resultCd);
    }
  } catch (error) {
    return {
      result: {
        jobDateTime: '',
        resultCd: '9999',
        resultMessageDtoList: [
          {
            resultMessageCd: '9999',
            resultMessage: `${API_EXCEPTION_MSG}  エラー内容:[${error}]`,
          },
        ],
      },
      hndlItmMngListResult: {
        hit: 0,
      },
    };
  }
}
